import NewExamCreator from "src/components/NewComponents/Creator/NewExamCreator";

import { CreatorContainer } from "./CreatorContainer";

function GenerateExam() {
	return (
		<CreatorContainer>
			<NewExamCreator />
		</CreatorContainer>
	);
}

export default GenerateExam;
